var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoultryBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3022",
    "data-name": "Group 3022",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.384,
    height: 53.327,
    viewBox: "0 0 56.384 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    d: "M237.4,118.561a1.3,1.3,0,1,1-1.3,1.3A1.3,1.3,0,0,1,237.4,118.561Z",
    transform: "translate(-227.68 -112.239)",
    fill: "#22294b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    "data-name": "Path 3353",
    d: "M248.535,168.094a1.113,1.113,0,0,1-.912-1.751,9.9,9.9,0,0,1,4.253-3.356l-.009-1.915v-.01a6.384,6.384,0,0,0-2.5-4.772,18.114,18.114,0,0,0-4.714-2.87,24.056,24.056,0,0,1-6.417-3.979,20.748,20.748,0,0,1-5.312-7.035,18.017,18.017,0,0,1-1.562-6.574,17.348,17.348,0,0,1,.972-6.778,1.113,1.113,0,0,1,2.063.836h0a15.443,15.443,0,0,0-.806,5.936,16.778,16.778,0,0,0,6.118,11.945,21.84,21.84,0,0,0,5.826,3.6,20.345,20.345,0,0,1,5.31,3.249,8.5,8.5,0,0,1,3.253,6.443l.013,2.693a1.1,1.1,0,0,1-.818,1.079,7.8,7.8,0,0,0-3.839,2.779A1.112,1.112,0,0,1,248.535,168.094Z",
    transform: "translate(-226.453 -114.767)",
    fill: "#22294b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M233.245,128.845a5,5,0,0,1-3.319-1.351,4.552,4.552,0,0,1-1.367-2.27,4.444,4.444,0,0,1,.353-2.971,1.113,1.113,0,1,1,2.011.955,2.142,2.142,0,0,0,.511,2.648,2.353,2.353,0,0,0,2.461.613,1.223,1.223,0,0,0,.664-.837,1.113,1.113,0,1,1,2.226.046,3.376,3.376,0,0,1-1.775,2.718A3.51,3.51,0,0,1,233.245,128.845Z",
    transform: "translate(-225.706 -113.028)",
    fill: "#22294b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M266.374,172.384a1.113,1.113,0,0,1-1.113-1.113v-5.014a5.248,5.248,0,0,1,4.344-5.163c6.348-1.132,13.182-5.466,13.182-12.308a1.113,1.113,0,1,1,2.226,0c0,8.123-7.784,13.21-15.017,14.5a3.024,3.024,0,0,0-2.508,2.971v5.014A1.113,1.113,0,0,1,266.374,172.384Z",
    transform: "translate(-235.201 -119.748)",
    fill: "#22294b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M258.919,153.026a17.264,17.264,0,0,1-6.614-1.277,17.6,17.6,0,0,1-4.825-2.981,1.113,1.113,0,0,1,1.514-1.632,15.642,15.642,0,0,0,4.165,2.558c4.49,1.864,10.419,1.315,14.1-1.307a6.154,6.154,0,0,0,2.92-5.347,1.113,1.113,0,1,1,2.222-.136,8.278,8.278,0,0,1-3.85,7.3,16.261,16.261,0,0,1-7.636,2.721A19.074,19.074,0,0,1,258.919,153.026Z",
    transform: "translate(-230.524 -118.249)",
    fill: "#22294b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    d: "M264.3,132.409a1.113,1.113,0,0,1-.327-2.177,31.23,31.23,0,0,0,3.63-1.4,2.336,2.336,0,0,0,1.524-1.959l-.085-.611a34.3,34.3,0,0,1-10.533,3.405,16.349,16.349,0,0,1-9.889-1.8,17.074,17.074,0,0,1-7.1-7.142,9.8,9.8,0,0,0-3.392-3.819l-.751-.5.328-.838a1.474,1.474,0,0,0-.466-1.743c-.642-.45-1.347.019-1.711.339l-1.266,1.113-.527-1.6a2.058,2.058,0,0,0-4.012.644,2.237,2.237,0,0,0,.57,1.449l1.333,1.458-1.938.385a6.689,6.689,0,0,0-1.384.391,1.838,1.838,0,0,0-.6.418,21.437,21.437,0,0,1,3.822.8,1.113,1.113,0,1,1-.7,2.114,23.786,23.786,0,0,0-4.867-.847l-1.2-.076.168-1.19a4.352,4.352,0,0,1,2.5-3.259q.174-.075.345-.137a4.34,4.34,0,0,1-.273-1.5,4.285,4.285,0,0,1,7.7-2.582,3.3,3.3,0,0,1,3.315.265,3.607,3.607,0,0,1,1.362,1.9,3.723,3.723,0,0,1,.128,1.6,12.164,12.164,0,0,1,3.482,4.176,14.614,14.614,0,0,0,14.728,7.771,33.513,33.513,0,0,0,11.188-3.887l1.407-.752.538,3.852,0,.051a3.915,3.915,0,0,1-.817,2.56,5.183,5.183,0,0,1-2.012,1.576,33.447,33.447,0,0,1-3.892,1.5A1.114,1.114,0,0,1,264.3,132.409Z",
    transform: "translate(-224.755 -110.044)",
    fill: "#22294b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M273.434,143.713a1.113,1.113,0,0,1-.325-2.178l4-1.221a3.128,3.128,0,0,0,2.158-3.613c-.01-.044-.017-.072-.019-.08a1.113,1.113,0,1,1,2.152-.57c0,.016.019.074.041.17v.006a5.271,5.271,0,0,1-.632,3.827,5.371,5.371,0,0,1-3.051,2.389l-4,1.221A1.112,1.112,0,0,1,273.434,143.713Z",
    transform: "translate(-237.022 -116.538)",
    fill: "#22294b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    d: "M287.373,138.13a1.113,1.113,0,0,1-.2-2.208c3.479-.637,5.8-1.887,6.9-3.715a4.865,4.865,0,0,0,.661-1.931,28.62,28.62,0,0,1-5.5,2.446,1.113,1.113,0,0,1-.672-2.122c1.27-.4,4.886-1.769,6.347-3.229l1.3-1.3.551,1.75a7.217,7.217,0,0,1-.78,5.532c-1.445,2.4-4.274,4-8.408,4.756A1.123,1.123,0,0,1,287.373,138.13Z",
    transform: "translate(-240.616 -114.179)",
    fill: "#22294b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    d: "M284.764,148.185a1.113,1.113,0,0,1-.1-2.222,13.576,13.576,0,0,0,4.17-.968,3.57,3.57,0,0,0,2.153-3.835,2.955,2.955,0,0,0-.77-1.581l.013.011,1.455-1.685a5.086,5.086,0,0,1,1.493,2.856,5.606,5.606,0,0,1-.644,3.746,5.974,5.974,0,0,1-2.813,2.53,15.764,15.764,0,0,1-4.858,1.144C284.831,148.183,284.8,148.185,284.764,148.185Z",
    transform: "translate(-239.945 -117.229)",
    fill: "#22294b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoultryBl);
export default __webpack_public_path__ + "static/media/Poultry-bl.4acffba0477dd149dcf2b56f42b21f79.svg";
export { ForwardRef as ReactComponent };